import config from '../config';
export default function headerProxy(environment) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (req, res, next) {
    var path;
    var _options$isBosun = options.isBosun,
        isBosun = _options$isBosun === void 0 ? false : _options$isBosun;
    var ENDPOINTS = isBosun ? config.BOSUN_ENDPOINTS : config.ENDPOINTS;

    if (environment === 'development') {
      path = ENDPOINTS.development;
    } else if (environment === 'staging') {
      path = ENDPOINTS.staging;
    } else {
      if (environment !== 'production') console.warn("HAAS: You didn't specify a valid environment, defaulting to production");
      path = ENDPOINTS.production;
    }

    req.argosHeaderProxyPath = "".concat(path, "/header-assets/*");
    next();
    return path;
  };
}